import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CarsWidgetFormType } from '../models/cars-widget-form.interfaces';
import { CarsWidget } from '../models/cars-widget.interface';
import {
  validatePickupDropoffTimeNotPassed,
  validateTimeRange
} from '../utils/cars-validation.utils';
import { DROPOFF_BEFORE_PICKUP } from '../utils/error-constants';

@Injectable({
  providedIn: 'root'
})
export class CarsFormValidationHelperService {
  setDropoffTimeError(
    form: FormGroup<CarsWidgetFormType>,
    content: CarsWidget
  ): string {
    const dropoffTimeError = this.getDropoffTimeError(form, content);
    if (dropoffTimeError) {
      return dropoffTimeError;
    }
    const timeRangeResult = validateTimeRange(
      form.controls['pickUpDate'].value,
      form.controls['dropOffDate'].value,
      form.controls['pickUpTime'].value,
      form.controls['dropOffTime'].value
    );
    if (!timeRangeResult.isValid) {
      if (timeRangeResult.errorType === DROPOFF_BEFORE_PICKUP) {
        return this.errorMessageValidate(
          content.errors.dropOffBeforePickupMessage
        );
      }
      return this.errorMessageValidate(content.errors.timeRangeErrorMessage);
    }
    return '';
  }

  errorMessageValidate(errorMessage: string | undefined) {
    return errorMessage || '';
  }

  getDropoffTimeError(
    form: FormGroup<CarsWidgetFormType>,
    content: CarsWidget
  ): string {
    const isDropoffTimeValid = validatePickupDropoffTimeNotPassed(
      form.controls['dropOffDate'].value,
      form.controls['dropOffTime'].value
    );
    return !isDropoffTimeValid
      ? content.errors.dropoffTimePassedErrorMessage || ''
      : '';
  }
}
